
import React from 'react';

const Copyright: React.FC = () => {
  return (
    <p className="text-gray-600 text-sm">
      &copy; {new Date().getFullYear()} ReferMe.site. All rights reserved.
    </p>
  );
};

export default Copyright;
